import React from "react";

function About() {

    return (
        <div className="About">
            <h1>About</h1>
            <blockquote className="blockquote">
                <p className="mb-0">Sound Explorer is a web app for a school final project.</p>
                <p className="mb-0">With this app you can explore all kinds of sound files, download them and use them
                    in your multimedia projects.</p>
                <footer className="blockquote-footer">Duarte Cancela in <cite title="Source Title">IPBEJA 2020</cite>
                </footer>
            </blockquote>
        </div>

    )

}

export default About;